import { useQuery, useMutation } from "@apollo/client/react";
import { GET_ULTIMO_PASO_INDEX } from '../../../data/graphQL/queries/MisVisitas/getLastStepId';
import { SAVE_ULTIMO_PASO_INDEX } from '../../../data/graphQL/mutations/Visitas/saveUltimoPasoIndex';
import { useEffect, useState } from 'react';
import { useVisita } from "../../../context/VisitaContext";

export const useUltimoPasoIndex = (idVisita, currentStackScreens) => {
  const initialIndex = currentStackScreens.findIndex(
    (screen) => screen.componentName === 'DatosDeVisitas'
  );
  const { visita } = useVisita();
  const [ultimoPasoIndex, setUltimoPasoIndex] = useState(initialIndex !== -1 ? initialIndex : 0);

  const { data, loading: loadingQuery } = useQuery(GET_ULTIMO_PASO_INDEX, {
    variables: { idVisita: visita.idVisita },
    skip: !visita.idVisita
  });

  const [updateUltimoPasoIndexMutation, { loading: loadingMutation }] = useMutation(SAVE_ULTIMO_PASO_INDEX);

  useEffect(() => {
    if (!!data?.visita?.ultimoPasoIndex) {
      setUltimoPasoIndex(data.visita.ultimoPasoIndex);
    } else {
      setUltimoPasoIndex(initialIndex !== -1 ? initialIndex : 0);
    }
  }, [data, currentStackScreens]);

  const updateUltimoPasoIndex = async (pasoIndex) => {
    try {
      await updateUltimoPasoIndexMutation({ variables: { idVisita: visita.idVisita, pasoIndex } });
      setUltimoPasoIndex(pasoIndex);
    } catch (err) {
      console.error('Error al actualizar ultimoPasoIndex:', err);
    }
  };

  return {
    ultimoPasoIndex,
    loading: loadingQuery || loadingMutation,
    updateUltimoPasoIndex
  };
};